import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DispositivoDetailComponent } from './dispositivo/dispositivo-detail.component';
import { ClienteService } from './services/cliente/cliente.service';
import { OrdineService } from './services/gestione-ordini/ordine.service';
import { PostazioneService } from './services/postazione/postazione.service';
import { PrenotazionePostazioneService } from './services/prenotazionepostazione/prenotazionepostazione.service';
import { CollaboratoreAmService } from './services/turno-am/collaboratore-am.service';
import { TipoTurnoAmService } from './services/turno-am/tipo-turno-am.service';
import { TurnoAmService } from './services/turno-am/turno-am.service';

import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ZXingScannerModule } from '@zxing/ngx-scanner';

import { L10nIntlModule, L10nLoader, L10nTranslationModule, L10nValidationModule } from 'angular-l10n';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppMaterialModule } from './app.material.module';
import { AppRoutingModule } from './app.routing.module';

import { AvatarModule } from 'ngx-avatar';
import { AppComponent } from './app.component';
import { DateFormatPipe } from './commons/dateFormatPipe';
import { FakeAuthenticationHeaderInterceptor } from './commons/fakeAuthenticationHeaderInterceptor';
import { ServerErrorInterceptor } from './commons/serverErrorInterceptor';
import { TimestampFormatPipe } from './commons/timestampFormatPipe';
import { GestioneTemplateDetailComponent } from './gestione-template/gestione-template-detail.component';
import { GestioneTemplateComponent } from './gestione-template/gestione-template.component';
import { AcquistoService } from './services/acquisti/acquisto.service';
import { AssenzaService } from './services/assenza/assenza.service';
import { ChiusuraService } from './services/assenza/chiusura.service';
import { ComponentCacheService } from './services/component-cache.service';
import { ComunicazioneService } from './services/comunicazioni/comunicazione.service';
import { CorsiUdemyService } from './services/corsi-udemy/corsi-udemy.service';
import { FrequentaCorsoService } from './services/corsi-udemy/frequenta-corso.service';
import { CatalogoService } from './services/credito/catalogo.service';
import { CreditoService } from './services/credito/credito.service';
import { MovimentoService } from './services/credito/movimento.service';
import { CollaboratoreService } from './services/domain/collaboratore.service';
import { TenantService } from './services/domain/tenant.service';
import { DatiAnagraficiSDIService } from './services/fattura-elettronica/datiAnagraficiSDI.service';
import { NavigatorService } from './services/navigator.service';
import { PrenotazioneService } from './services/prenotazione/prenotazione.service';
import { PrenotazioneSalettaService } from './services/prenotazioneSaletta/prenotazione-saletta.service';
import { LocationService } from './services/presenze/location.service';
import { PresenzaService } from './services/presenze/presenza.service';
import { PropostaService } from './services/proposte/proposta.service';
import { VotoService } from './services/proposte/voto.service';
import { QrcodeService } from './services/qrcode.service';
import { NumeroService } from './services/reperibilità/numero.service';
import { SalettaService } from './services/saletta/saletta.service';
import { SedeService } from './services/sede/sede.service';
import { TorneoDetailComponent } from './torneo/torneo-detail.component';
import { TorneoComponent } from './torneo/torneo.component';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { UrlService } from './commons/calendar/prevUrl.service';
import { DispositivoComponent } from './dispositivo/dispositivo.component';
import { FerieComponent } from './gestione-ferie/ferie.component';
import { AppStorage, HttpTranslationLoader, initL10n, l10nConfig, LocaleValidation } from './l10n-config';
import { NumeriComponent } from './numeri-reperibilità/numeri.component';
import { ColloquioService } from './services/colloquio/colloquio.service';
import { ColloquioConoscitivoService } from './services/colloquio/colloquio-conoscitivo.service';
import { CompleanniService } from './services/compleanni/compleanni.service';
import { NascondiComunicazioneService } from './services/comunicazioni/nascondiComunicazione';
import { DomoticaService } from './services/domotica/domotica.service';
import { ComandaService } from './services/gestione-ordini/comanda.service';
import { GreenPassService } from './services/green-pass/green-pass.service';
import { ListaAttesaPrenotazionePostazioneService } from './services/lista-attesa-prenotazionepostazione/lista-attesa-prenotazione-postazione-service.service';
import { MalattiaService } from './services/malattia/malattia.service';
import { MenuService } from "./services/menu/menu.service";
import { OrarioLavorativoService } from './services/orario-lavorativo/orario-lavorativo.service';
import { PrenotazioneStampante3DService } from './services/prenotazione-stampante3D/prenotazione-stampante3D.service';
import { RisorsaAziendaleService } from './services/risorsa-aziendale/risorsa-aziendale.service';
import { SondaggioService } from './services/sondaggio/sondaggio.service';
import { SondaggioRispostaService } from './services/sondaggio/sondaggioRisposta.service';
import { Stampante3DService } from './services/stampante3D/stampante3D.service';
import { TorneoService } from './services/torneo/torneo.service';
import { CreazioneSondaggiDetailComponent } from './sondaggi/creazione-sondaggi-detail/creazione-sondaggi-detail.component';
import { CreazioneSondaggiComponent } from './sondaggi/creazione-sondaggi/creazione-sondaggi.component';
import { SondaggioRispostaDetailComponent } from './sondaggi/risposta-sondaggio-detail/risposta-sondaggio-detail.component';
import { SondaggioRispostaComponent } from './sondaggi/risposta-sondaggio/risposta-sondaggio.component';
import { RisultatiSondaggioComponent } from './sondaggi/risultati-sondaggio/risultati-sondaggio.component';
import { TurnoDetailComponent } from './torneo/turno-detail.component';
import { TurniComponent } from './turni-reperibilità/turni.component';
import { VisualizzaPresenzeComponent } from './visualizza-presenze/visualizza-presenze.component';
import { ColloquioConoscitivoComponent } from './colloquio-conoscitivo/colloquio-conoscitivo.component';
import { ColloquioConoscitivoDetailComponent } from './colloquio-conoscitivo/colloquio-conoscitivoDetail.component';
import { DeviceTypeService } from './services/device-aziendali/device-type.service';
import { DeviceAziendaleService } from './services/device-aziendali/device.service';
import { DeviceTypeDetailComponent } from './device-aziendali/deviceTypeDetail.component';
import { DeviceTypeComponent } from './device-aziendali/deviceType.component';
import { DeviceComponent } from './device-aziendali/devices.component';
import { DeviceDetailComponent } from './device-aziendali/devicesDetail.component';
import { SoftwareComponent } from './device-aziendali/software.component';
import { SoftwareService } from './services/device-aziendali/software.service';
import { SoftwareDetailComponent } from './device-aziendali/softwareDetail.component';

@NgModule({
  declarations: [
    AppComponent,
    DateFormatPipe,
    TimestampFormatPipe,
    GestioneTemplateComponent,
    GestioneTemplateDetailComponent,
    TorneoComponent,
    TorneoDetailComponent,
    TurnoDetailComponent,
    DispositivoComponent,
    DispositivoDetailComponent,
    VisualizzaPresenzeComponent,
    FerieComponent,
    NumeriComponent,
    TurniComponent,
    CreazioneSondaggiComponent,
    SondaggioRispostaComponent,
    CreazioneSondaggiDetailComponent,
    SondaggioRispostaDetailComponent,
    RisultatiSondaggioComponent,
	ColloquioConoscitivoComponent,
	ColloquioConoscitivoDetailComponent,
    DeviceTypeDetailComponent,
    DeviceTypeComponent,
    DeviceDetailComponent,
    DeviceComponent,
    SoftwareComponent,
    SoftwareDetailComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    HttpClientModule,
    MatCheckboxModule,
    ZXingScannerModule,
    AppMaterialModule,
    AppRoutingModule,
    AvatarModule,
    MatAutocompleteModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    OAuthModule.forRoot({
      resourceServer: {
          sendAccessToken: true
      }
    }),
    L10nTranslationModule.forRoot(
      l10nConfig,
      {
          storage: AppStorage,
          translationLoader: HttpTranslationLoader
      }
    ),
    L10nIntlModule,
    L10nValidationModule.forRoot({ validation: LocaleValidation }),
  ],
  exports: [
    DateFormatPipe,
    TimestampFormatPipe
  ],
  providers: [
    NavigatorService,
    QrcodeService,
    TenantService,
    CollaboratoreService,
    LocationService,
    NumeroService,
    GreenPassService,
    ComandaService,
    OrdineService,
    SalettaService,
    SedeService,
    PrenotazioneSalettaService,
    DatiAnagraficiSDIService,
    PresenzaService,
    AssenzaService,
    ChiusuraService,
    ClienteService,
    CompleanniService,
    ComunicazioneService,
    NascondiComunicazioneService,
    ColloquioService,
    ColloquioConoscitivoService,
    CreditoService,
    CatalogoService,
    MovimentoService,
    AcquistoService,
    PropostaService,
    MalattiaService,
    VotoService,
    PrenotazioneService,
    PrenotazionePostazioneService,
    SedeService,
    ComponentCacheService,
    PostazioneService,
    RisorsaAziendaleService,
    TipoTurnoAmService,
    CollaboratoreAmService,
    TurnoAmService,
    CorsiUdemyService,
    FrequentaCorsoService,
    DateFormatPipe,
    TimestampFormatPipe,
    UrlService,
    TorneoService,
    MenuService,
    ListaAttesaPrenotazionePostazioneService,
    OrarioLavorativoService,
    Stampante3DService,
    PrenotazioneStampante3DService,
	  DomoticaService,
    SondaggioService,
    SondaggioRispostaService,
    DeviceTypeService,
    DeviceAziendaleService,
    SoftwareService,
    [{
      provide: HTTP_INTERCEPTORS,
      useClass: FakeAuthenticationHeaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true
    }],
    {
      provide: APP_INITIALIZER,
      useFactory: initL10n,
      deps: [L10nLoader],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
